<template>
  <div class="progress">
    <div class="list" v-for="(item, i) in progress" :key="i">
      <div class="list-part">{{item.commerDescribe}} <span>{{item.creator}}</span></div>
      <div class="list-time">{{item.createTime}}</div>
      <div class="list-text" v-if="item.remark">备注：<span>{{item.remark}}</span></div>
    </div>
  </div>
</template>
<script>
import { processDetail } from '@api/commissioner/commissioner'
import { Toast } from 'vant'
export default {
  data() {
    return {
      progress: []
    }
  },
  mounted() {
    this.getProgress()
  },
  methods: {
    getProgress() {
      processDetail({ id: this.$route.query.id }).then(res => {
        const { code, data, msg } = res.data
        if (code == '0000') {
          this.progress = data
        } else {
          Toast(msg)
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.progress{
  padding:30px;
  box-sizing: border-box;
  .list{
    padding:4px 0 50px 30px;
    border-left:2px solid #1890FF;
    position:relative;
    &:last-child{
      border:none;
    }
    &:before{
      content:'';
      display:block;
      width:12px;
      height:12px;
      background:#1890FF;
      border-radius:50%;
      border:10px solid #F8F9FC;
      position:absolute;
      left:-16px;
      top:0;
    }
    .list-part{
      font-size:14px;
      span{
        color:#999;
      }
    }
    .list-time{
      font-size:14px;
      color:#999;
      margin-top:4px;
    }
    .list-text{
      font-size:14px;
      color:#999;
      margin-top:8px;
      span{
        color:#333;
      }
    }
  }
}
</style>
